import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { AttendanceItemListSearchSchema } from '../-shared/attendance-item-list-search-schema';
export const Route = createFileRoute('/_staff/attendance-engine/_layout/items/')({
  validateSearch: zodValidator(AttendanceItemListSearchSchema)
});